import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import numeral from 'numeral';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
import infoModal from '../../assets/info-modal-1.png';

NoDataToDisplay(Highcharts);

class DebriefItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
      popup: false,
    };

    // Bindings
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.dispatch(gameActions.fetchGames(this.props.match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { popup } = this.state;
    const { game } = this.props;
    const gameData = game.data;

    // Loop Levels
    const levelsData = gameData.levels.map((l) => {
      // Level data
      const levelResults = gameData.players.reduce(
        (accp, p) => {
          const onlyLevel = p.results.filter((r) => r.level.id === l.id);
          const playerLevelROW = onlyLevel.reduce(
            (placc, plr) => {
              placc[0] += plr.cal_selection.correct ? 0 : 1;
              placc[1] += plr.cal_selection.correct ? 1 : 0;
              return placc;
            },
            [0, 0]
          );
          accp[0] += playerLevelROW[0];
          accp[1] += playerLevelROW[1];
          return accp;
        },
        [0, 0]
      );

      return levelResults;
    });

    // console.log(levelsData);
    const totalData = levelsData.reduce(
      (acc, levelROR) => {
        acc[0] += levelROR[0];
        acc[1] += levelROR[1];
        return acc;
      },
      [0, 0]
    );

    return (
      <div>
        <Header />

        <h2 className='mt-3 sec-title'>
          Item Selection{' '}
          <FontAwesomeIcon
            className='ml-1 text-secondary'
            style={{ fontSize: '1.25rem', cursor: 'pointer' }}
            icon='question-circle'
            onClick={() => this.setState({ popup: !popup })}
          />{' '}
          <small class='float-right'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2>

        <div className='mt-3'>
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              title: { text: '' },
              chart: { type: 'column', height: '500px' },
              credits: { enabled: false },
              legend: { enabled: true },
              xAxis: {
                categories: [
                  'Total',
                  ...gameData.levels.map((l, li) => l.title),
                ],
              },
              yAxis: {
                labels: { style: { fontSize: '14px' } },
                allowDecimals: false,
                min: 0,
                title: {
                  text: '',
                },
                stackLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color:
                      (Highcharts.theme && Highcharts.theme.textColor) ||
                      'gray',
                  },
                },
              },
              lang: {
                noData: 'Pending results',
              },
              plotOptions: {
                column: {
                  stacking: 'normal',
                  dataLabels: {
                    enabled: true,
                    formatter: function () {
                      if (this.percentage != 0)
                        return numeral(this.percentage).format('0') + '%';
                    },
                  },
                },
                series: {
                  cursor: 'pointer',
                  // borderWidth: 5,
                  // borderColor: 'black',
                },
              },
              series: [
                {
                  name: 'Incorrect',
                  // color: 'rgba(223, 83, 83, 1)',
                  // color: 'rgba(223, 83, 83, 1)',
                  data: [totalData[0], ...levelsData.map((ld) => ld[0])],
                },
                {
                  name: 'Correct',
                  // color: 'green',
                  // color: 'rgba(80,180,50, 1)',
                  data: [totalData[1], ...levelsData.map((ld) => ld[1])],
                },
              ],
            }}
          />
        </div>

        <Modal
          isOpen={popup}
          toggle={() => this.setState({ popup: !popup })}
          centered={true}
          size={'lg'}>
          <ModalHeader>Item Selection</ModalHeader>
          <ModalBody>
            <div className='row'>
              <div className='col-6 text-center'>
                <img src={infoModal} alt='Plotted Function' />
                <table
                  className='table table-sm table-bordered mmb-0 text-center'
                  style={{
                    width: '50%',
                    margin: '20px auto 0',
                    fontSize: '.9rem',
                  }}>
                  <tbody>
                    <tr>
                      <td id=''>
                        <strong>$</strong>
                      </td>
                      <td id='demand0'>0</td>
                      <td id='demand1'>30</td>
                      <td id='demand2'>60</td>
                      <td id='demand3'>90</td>
                      <td id='demand4'>120</td>
                      <td id='demand5'>150</td>
                    </tr>
                    <tr>
                      <td id=''>
                        <strong>K</strong>
                      </td>
                      <td id='price0'>1108</td>
                      <td id='price1'>29,730</td>
                      <td id='price2'>72,010</td>
                      <td id='price3'>85,250</td>
                      <td id='price4'>97,320</td>
                      <td id='price5'>91,230</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className='col-6'>
                <ul className='mt-3 mb-0'>
                  <li className='mb-3'>
                    Students are presented with a chart of estimated demand, or
                    a table with similar information.
                  </li>
                  <li className='mb-3'>
                    Students can quickly identify the item with the greatest
                    estimated revenue, for most items.
                  </li>
                  <li>
                    However, some items have very similar data visualizations.
                    In these cases, students are can use the functions provided
                    to identify the optimal item to select.
                  </li>
                </ul>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              className='btn btn-outline-primary'
              onClick={() => this.setState({ popup: false })}>
              Close
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefItems);
